import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/school-classes/$id")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/groups/$id",
      params,
    });
  },
});
